import "angular"

import "front-end-web-commons"
import filterModule from "front-end-web-commons/app/filter/filterModule"
import authenticationModule from "../authentication/authenticationModule"
import addressModule from "front-end-web-commons/app/address/addressModule"
import mapsModule from "front-end-web-commons/app/maps/mapsModule"
import regionModule from "front-end-web-commons/app/region/regionModule"
import routingConfigModule from "front-end-web-commons/app/routingConfig/routingConfigModule"
import analysisModule from "../analysis/analysisModule"
import monitoringCommonsModule from "front-end-web-commons/app/monitoringCommons/monitoringCommonsModule"
import nodeCommandsModule from "front-end-web-commons/app/nodeCommands/nodeCommandsModule"
import commonsCancellationModule from "front-end-web-commons/app/cancellation/commonsCancellationModule"
import tollModule from "front-end-web-commons/app/toll/tollModule"
import externalFreightModule from "front-end-web-commons/app/externalFreight/externalFreightModule"
import commonsOperationModule from "front-end-web-commons/app/operation/commonsOperationModule"
import commonsUserModule from "front-end-web-commons/app/user/commonsUserModule"
import moveToAnotherUserModule from "front-end-web-commons/app/moveToAnotherUser/moveToAnotherUserModule"
import moveTripsToUserModule from "front-end-web-commons/app/moveTripsToUser/moveTripsToUserModule"
import pathModule from "front-end-web-commons/app/path/pathModule"
import dashboardModule from "front-end-web-commons/app/dashboards/dashboardModule"
import nlgTagInputModule from "front-end-web-commons/app/nlgTagInput/nlgTagInputModule"
import nlgPermissionModule from "front-end-web-commons/app/nlgPermission/nlgPermissionModule"
import nlgSelectionModule from "front-end-web-commons/app/nlgSelection/nlgSelectionModule"
import classifiableModule from "front-end-web-commons/app/classifiable/classifiableModule"
import commonsOptimizationModule from "front-end-web-commons/app/optimization/commonsOptimizationModule"
import tripPickingListModule from "front-end-web-commons/app/tripPickingList/tripPickingListModule"
import {integration, server} from "../server"
import gatewayServer from "../gatewayServer"
import dashboardServer from "../dashboardServer"
import monitoringServer from "../monitoringServer"
import trackingServer from "../trackingServer"
import serviceNameByEntityClass from "./serviceNameByEntityClass.json"
import userManagementServer from "../userManagementServer"
import trackingMobileServer from "../trackingMobileServer"
import workHoursControlServer from "monitoring/app/workHoursControl/config/workHoursControl.json"
import violationModule from "front-end-web-commons/app/violation/violationModule"
import translateModule from "front-end-web-commons/app/translate/translateModule"
import stateByEntityType from "./stateByEntityType.json"
import trackingModule from "nlg-tracking/app/tracking/trackingModule"
import monitorModule from "front-end-web-commons/app/monitor/monitorModule"
import nlgTruckAllocationModule from "front-end-web-commons/app/nlgTruckAllocation/nlgTruckAllocationModule"
import nlgLGPDModule from "front-end-web-commons/app/nlgLGPD/nlgLGPDModule"
import tdnHelpModule from "front-end-web-commons/app/tdnHelp/tdnHelpModule"
import passwordConfigModule from "front-end-web-commons/app/nlgPassword/nlgPasswordModule"
import commonScriptModule from "front-end-web-commons/app/commonScript/commonScriptModule"
import genericParamsModule from "front-end-web-commons/app/genericParams/genericParamsModule"
import backgroundTaskJobModule from "front-end-web-commons/app/backgroundTaskJob/backgroundTaskJobModule"
import clientViewConfigurationServer from "monitoring/app/clientViewConfiguration/config/clientViewConfiguration.json"
import restrictionConfigurationServer
    from "monitoring/app/restrictionConfiguration/config/restrictionConfiguration.json"
import microstrategyModule from "front-end-web-commons/app/nlgMicrostrategy/microstrategyModule"
import remoteServerModule from "front-end-web-commons/app/remoteServer/remoteServerModule"
import tripOperationHistoryModule from "front-end-web-commons/app/tripOperationHistory/tripOperationHistoryModule"
import userPreferencesModule from "front-end-web-commons/app/userPreferences/userPreferencesModule"
import hereMapsModule from "front-end-web-commons/app/hereMaps/hereMapsModule"

import {integrationDocumentationModule, integrationValidatorModule, remoteRoutingModule} from "programming-front-end"
import {monitoringIntegrationModule} from "monitoring/app/monitoringIntegration/monitoringIntegration"

import FileSaver from "file-saver"
import JSZip from "jszip"
import pdfMake from "pdfmake"
import pdfFonts from "pdfmake/build/vfs_fonts"

filterModule.config(["filterDomainProvider", (filterDomainProvider) => {
    filterDomainProvider.registerDomain("r2", server.getBaseUrl())
    filterDomainProvider.setDefaultDomain("r2")
    filterDomainProvider.registerDomain("monitoring", monitoringServer.getMonitoringUrl())
    filterDomainProvider.registerDomain("usermanagement", userManagementServer.getBaseUrl())
    filterDomainProvider.registerDomain("tracking", trackingServer.getBaseUrl())
    filterDomainProvider.registerDomain("tracking-mobile", trackingMobileServer.getBaseUrl())
    filterDomainProvider.registerDomain("work-hours-control", workHoursControlServer.baseUrl)
    filterDomainProvider.registerDomain("client-view-configuration", clientViewConfigurationServer.baseUrl)
    filterDomainProvider.registerDomain("lgpd", "/cockpit-gateway/r2-server/r2")
    filterDomainProvider.registerDomain("restriction-configuration", restrictionConfigurationServer.baseUrl)
}])
    .service("filterService", ["filterServiceFactory", function (filterServiceFactory) {
        return filterServiceFactory("r2")
    }])
    .run(["filterConfiguration", "autocompleteFactory", function (filterConfiguration, autocompleteFactory) {
        filterConfiguration.setFilterGenericAttribute(function (viewValue, additionalInfo) {
            return autocompleteFactory.lazyLoader("generic-attribute", [], additionalInfo)(viewValue)
        })
    }])

classifiableModule.run(["classifiableService", "autocompleteFactory", function (classifiableService, autocompleteFactory) {
    classifiableService.setClassificationsProviderCallback(function (classificationType, viewValue) {
        return autocompleteFactory.lazyLoader("classification", [classificationType], {})(viewValue)
    })
}])

authenticationModule.run(["authenticationService", "filterState", (authenticationService, filterState) => {
    authenticationService.addAuthenticationCallback({
        onLogOut() {
            filterState.reset()
        }
    })
}])

addressModule.config(["addressServiceUrlsProvider", (addressServiceUrlsProvider) => {
    addressServiceUrlsProvider.setUrl({
        countryUrl: "country",
        stateUrl: "state",
        cityUrl: "city",
        geocodingUrl: server.getServiceUrl("geocoding")
    })
}])

addressModule.config(["viaCepServiceUrlProvider", function (viaCepServiceUrlProvider) {
    viaCepServiceUrlProvider.configure({
        addressByZipCode: server.getServiceUrl("viaCepAddressByZipCode")
    })
}])

regionModule.config(["regionServiceUrlsProvider", (regionServiceUrlsProvider) => {
    regionServiceUrlsProvider.setUrl({
        regionGroupsUrl: "regionGroup",
        regionsByRegionGroupUrlSupplier: function (regionGroupId) {
            return server.getServiceUrl("regionGroup") + regionGroupId + "/regions"
        }
    })
}])

let mapsConfigured = false
let mapsConfigProvider = null

mapsModule.config(["mapsConfigGetterProvider", function (mapsConfigGetterProvider) {
    mapsConfigProvider = mapsConfigGetterProvider
}])
    .config(["mapsPathServiceUrlProvider", function (mapsPathServiceUrlProvider) {
        mapsPathServiceUrlProvider.configure({
            routePathUrl: server.getServiceUrl("serverRouteOSM")
        })
    }])
    .run(["authenticationService", "$http", (authenticationService, $http) => {
        const onLogIn = () => {
            if (mapsConfigured) {
                return
            }
            mapsConfigured = true
            $http.get(server.getServiceUrl("googleMaps"))
                .then(function (response) {
                    const mapsConfig = response.data
                    mapsConfig.maxStops = parseInt(mapsConfig.maxStops, 10)
                    mapsConfigProvider.registerMapsConfig(mapsConfig)
                })
        }
        authenticationService.addAuthenticationCallback({onLogIn})
        authenticationService.validateToken()
    }])
    .run(["routeStopPopupService", "routeStopPopupCreationService", function (routeStopPopupService, routeStopPopupCreationService) {
        routeStopPopupService.setDelegate(routeStopPopupCreationService)
    }])
    .config(["carrierZoneGrouperServiceProvider", function (carrierZoneGrouperServiceProvider) {
        let serviceUrl = server.getServiceUrl("polygon-carrier-zone-groupers")
        carrierZoneGrouperServiceProvider.setPolygonCarrierZoneGrouperUrl(serviceUrl)
    }])
    .config(["alterStopsServiceProvider", function (alterStopsServiceProvider) {
        alterStopsServiceProvider.configure({
            moveStopUrl: server.getServiceUrl("move-stops"),
            manualOperationSaveUrl: server.getServiceUrl("manualOperationSave"),
            doAlterStopsUrl: server.getServiceUrl("alter-stops"),
            doAlterStopsForTripsUrl: server.getServiceUrl("alter-stop-trips")
        })
    }])

analysisModule.config(["routeServiceUrlProvider", function (routeServiceUrlProvider) {
    routeServiceUrlProvider.configure({
        routeUrlForNodeIdentifier: server.getServiceUrl("routeUrlForNodeIdentifier"),
        routeUrlForTripIds: server.getServiceUrl("routeUrlForTripIds"),
        alterStopsUrl: server.getServiceUrl("trip.stops")
    })
}])

tollModule.config(["tollServiceUrlProvider", function (tollServiceUrlProvider) {
    tollServiceUrlProvider.configure({
        calculateTollUrlForNodeIdentifier: server.getServiceUrl("calculateTollUrlForNodeIdentifier")
    })
}])

externalFreightModule.config(["externalFreightServiceUrlProvider", function (externalFreightServiceUrlProvider) {
    externalFreightServiceUrlProvider.configure({
        calculateFreightUrlForNodeIdentifier: server.getServiceUrl("calculateFreightUrlForNodeIdentifier"),
        selectExternalFreight: server.getServiceUrl("selectExternalFreight")
    })
}])

tripPickingListModule.config(["tripPickingListServiceUrlProvider", function (tripPickingListServiceUrlProvider) {
    tripPickingListServiceUrlProvider.configure({
        tripPickingListUrlForNodeIdentifier: server.getServiceUrl("tripPickingListUrlForNodeIdentifier")
    })
}])

tripPickingListModule.config(["tripPickingListServiceImagesProvider", function (tripPickingListServiceImagesProvider) {
    tripPickingListServiceImagesProvider.configure({
        images: {
            assign: require("../../images/pdf_assign.png"),
            bothIcon: require("../../images/loadunload.png"),
            logo: require("../../images/logo-totvs-black.png"),
            loadingIcon: require("../../images/loading.png"),
            unloadingIcon: require("../../images/unloading.png"),
        }
    })
}])

tripPickingListModule.config(["tripPickingListServiceDependenciesProvider", function (tripPickingListServiceDependenciesProvider) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs
    tripPickingListServiceDependenciesProvider.configure({
        dependencies: {
            "JSZip": JSZip,
            "FileSaver": FileSaver,
            "pdfMake": pdfMake
        }
    })
}])

routingConfigModule.config(["routingSelectionDialogProvider", function (routingSelectionDialogProvider) {
    routingSelectionDialogProvider.setRoutingConfigSelectorServiceUrl(server.getServiceUrl("routingConfigSelector"))
}])

monitoringCommonsModule.config(["monitoringCommonsServiceUrlsProvider", function (monitoringCommonsServiceUrlsProvider) {
    monitoringCommonsServiceUrlsProvider.setUrl({
        filterTemplateUrl: monitoringServer.getServiceUrl("trip"),
        filterUrl: monitoringServer.getServiceUrl("tripFilter"),
    })
}])

userPreferencesModule.config(["monitoringUserPreferencesPropertiesProvider", "planningUserPreferencesPropertiesProvider", function (monitoringUserPreferencesProperties, planningUserPreferencesPropertiesProvider) {
    monitoringUserPreferencesProperties.setActivateStorePreferences(true)
    planningUserPreferencesPropertiesProvider.setActivateStorePreferences(true)
}])

nodeCommandsModule.run(["rootNodeCommandExecutorSupplier", "r2NodeCommands", function (rootNodeCommandExecutorSupplier, r2NodeCommands) {
    rootNodeCommandExecutorSupplier.setRoot(r2NodeCommands)
}])

commonsCancellationModule.run(["cancellationServiceInvoker", "r2CancellationService", function (cancellationServiceInvoker, r2CancellationService) {
    cancellationServiceInvoker.setService(r2CancellationService)
}])

commonsOperationModule.run(["organizeService", "organizeModal", function (organizeService, organizeModal) {
    organizeService.setModalService(organizeModal)
}])
    .run(["preViolationModal", "$state", function (preViolationModal, $state) {
        preViolationModal.setLocalityEditionCallback(function (localityId, version) {
            return $state.href("r2.edition", {entityType: "locality", entityId: localityId, version: version})
        })
    }])

pathModule.config(["pathServiceProvider", function (pathServiceProvider) {
    pathServiceProvider.setPaths({
        "preValidation-optimization": server.getServiceUrl("preValidation-optimization"),
        "preValidation-manualOperation": server.getServiceUrl("preValidation-manualOperation"),
        "organize": server.getServiceUrl("organize"),
        "organize-execute": server.getServiceUrl("organize-execute"),
        "manualOperation-save": server.getServiceUrl("manualOperationSave"),
        "alter-stops": server.getServiceUrl("alter-stops"),
        "alter-stop-trips": server.getServiceUrl("alter-stop-trips"),
        "geocodeAndStamp": server.getServiceUrl("geocodeLocalities"),
        "finalize-trip": server.getServiceUrl("finalize-trip"),
        "move-trip-to-user": server.getServiceUrl("move-trip-to-user"),
        "move-deliveryunit-to-user": server.getServiceUrl("move-deliveryunit-to-user"),
        "users": server.getRelativeUrl("users"),
        "operation-overview": server.getServiceUrl("operation-overview"),
        "permission-group-inactivate": userManagementServer.getServiceUrl("permission-group-inactivate"),
        "purge": userManagementServer.getServiceUrl("purge"),
    })
}])

commonsOptimizationModule.run(["optimizationServiceInvoker", "r2OptimizationService", function (optimizationServiceInvoker, r2OptimizationService) {
    optimizationServiceInvoker.setService(r2OptimizationService)
}])

dashboardModule.config(["dashboardDomainProvider", function (dashboardDomainProvider) {
    dashboardDomainProvider.setDefaultDomain("r2")
    dashboardDomainProvider.registerDomain("r2", dashboardServer.getDashboardUrl())
    dashboardDomainProvider.setDashboardPaths("r2", {
        infoUrl: dashboardServer.getServiceUrl("info"),
        queryUrl: dashboardServer.getServiceUrl("query"),
        exportChartUrl: dashboardServer.getServiceUrl("export"),
        countExportUrl: dashboardServer.getServiceUrl("countExport")
    })
    dashboardDomainProvider.registerDomain("gcp-overview", server.getBaseUrl() + "/gcp-overview")
    dashboardDomainProvider.setDashboardPaths("gcp-overview", {
        infoUrl: dashboardServer.getServiceUrl("info"),
        queryUrl: dashboardServer.getServiceUrl("query"),
        exportChartUrl: dashboardServer.getServiceUrl("export"),
        countExportUrl: dashboardServer.getServiceUrl("countExport")
    })
    dashboardDomainProvider.registerDomain("gcp-resource", server.getBaseUrl() + "/gcp-resource-overview")
    dashboardDomainProvider.setDashboardPaths("gcp-resource", {
        infoUrl: dashboardServer.getServiceUrl("info"),
        queryUrl: dashboardServer.getServiceUrl("query"),
        exportChartUrl: dashboardServer.getServiceUrl("export"),
        countExportUrl: dashboardServer.getServiceUrl("countExport")
    })
}]).run(["spreadsheetServiceInvoker", "oldSpreadsheetService", function (spreadsheetServiceInvoker, oldSpreadsheetService) {
    spreadsheetServiceInvoker.setService(oldSpreadsheetService)
}])

commonsUserModule.config(["commonsUserServiceProvider", function (commonsUserServiceProvider) {
    commonsUserServiceProvider.setCurrentUserUrl(server.getServiceUrl("current-user"))
}])

moveToAnotherUserModule.config(["moveToAnotherUserModalProvider", function (moveToAnotherUserModalProvider) {
    moveToAnotherUserModalProvider.shouldLoadCurrentUser(true)
}])

moveTripsToUserModule.config(["moveTripsToUserModalProvider", function (moveTripsToUserModalProvider) {
    moveTripsToUserModalProvider.shouldLoadCurrentUser(true)
}])

nlgTagInputModule.config(["nlgTagInputLinkServiceProvider", function (nlgTagInputLinkServiceProvider) {
    const hasOwnProperty = Object.hasOwnProperty
    nlgTagInputLinkServiceProvider.setLinkService(function (tag) {
        if (!tag.entityClass) {
            return null
        }
        if (tag.entityClass === "br.com.neolog.model.entity.dto.LGPDObfuscatedEntityDTO") {
            //utilizado para remover o link da entidade ofuscada
            //Issue - NLGPRODUTO-1704/NLGPRODUTO-2196
            return null
        }
        if (!hasOwnProperty.call(serviceNameByEntityClass, tag.entityClass)) {
            return null
        }
        return `r2.edition({ entityType: '${serviceNameByEntityClass[tag.entityClass]}', entityId: ${tag.id} })`
    })
}])

nlgPermissionModule.config(["permissionServiceProvider", function (permissionServiceProvider) {
    permissionServiceProvider.setAuthorizationUrl(server.getServiceUrl("authorization"))
}])

nlgSelectionModule.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state("r2.selection", {
        data: {
            pageTitle: "{{'title.r2.selection' | translate}}",
            group: "group.r2.programming.selection"
        },
        url: "/programming/selection",
        template: `<nlg-selection-view></nlg-selection-view>`
    })
}]).config(["nlgSelectionServiceProvider", function (nlgSelectionServiceProvider) {
    nlgSelectionServiceProvider.setOrderBasketSelectionUrl(server.getServiceUrl("orderBasketSelectionUrl"))
}])

violationModule.config(["dtoLinkServiceProvider", (dtoLinkServiceProvider) => {
    dtoLinkServiceProvider.setRouteSupplier((dto) => {
        return `r2.edition({ entityType: '${stateByEntityType[dto.type]}', entityId: ${dto.id} })`
    })
}])

translateModule.config(["$translateProvider", ($translateProvider) => {
    $translateProvider.usePostCompiling(true)
}])

trackingModule.config(["markerImageProvider", function (markerImageProvider) {
    var image = {
        icon: "images/truck_new.png",
        violationIcon: "images/truck_violation.png",

        created: "images/truck_created.png",
        inExecution: "images/truck_in_execution.png",
        delayed: "images/truck_delayed.png",
        inService: "images/truck_in_service.png",
        pendingOccurrence: "images/truck_pending_occurrence.png",
        withoutMonitorable: "images/truck_without_monitorable.png",

        signal_late: "images/signal_late.png",
        created_late: "images/truck_created_late.png",
        inExecution_late: "images/truck_in_execution_late.png",
        delayed_late: "images/truck_delayed_late.png",
        inService_late: "images/truck_in_service_late.png",
        pendingOccurrence_late: "images/truck_pending_occurrence_late.png",
        withoutMonitorable_late: "images/truck_without_monitorable_late.png",
    }
    markerImageProvider.setIcon(image)
}])

monitorModule.config(["monitorUrlServiceProvider", function (monitorUrlServiceProvider) {
    monitorUrlServiceProvider.setGatewayUrl("/cockpit-gateway/")
}])

nlgTagInputModule.config(["nlgTagInputIconMapProvider", function (nlgTagInputIconMapProvider) {
    var defaultIconPath = "/images/loading2.gif"
    nlgTagInputIconMapProvider.config(defaultIconPath)
}]).run(["nlgTagInputIconMapMonitoring", "nlgTagInputIconMap", function (nlgTagInputIconMapMonitoring, nlgTagInputIconMap) {
    nlgTagInputIconMap.addIcons(nlgTagInputIconMapMonitoring.iconMap())
}])

nlgTruckAllocationModule.config(["nlgTruckAllocationProvider", function (nlgTruckAllocationProvider) {
    nlgTruckAllocationProvider.setFilterService({
        filter: server.getRelativeUrl("truck-allocation"),
        service: server.getServiceUrl("truck-allocation"),
        find: server.getServiceUrl("truck-allocation") + "/find"
    })
}])

tdnHelpModule.config(["tdnHelpProvider", function (tdnHelpProvider) {
    tdnHelpProvider.setContext("TRE")
}])

passwordConfigModule.config(["passwordConfigProvider", function (passwordConfigProvider) {
    passwordConfigProvider.configureShowValidationTooltip(true)
}])

commonScriptModule.config(["scriptUrlsProvider", function (scriptUrlsProvider) {
    scriptUrlsProvider.setUrls({
        autocompleteUrl: "script",
        scriptValidator: server.getServiceUrl("script-scriptValidator"),
        scriptTypes: server.getServiceUrl("script-scriptTypes"),
        requiredGenericParams: server.getServiceUrl("script-requiredGenericParams"),
    })
}])

genericParamsModule.config(["genericParamsUrlsProvider", function (genericParamsUrlsProvider) {
    genericParamsUrlsProvider.setUrls({
        basePath: server.getBaseUrl(),
        genericParamDataUrl: server.getRelativeUrl("genericParams"),
        genericParamComponents: server.getServiceUrl("genericParamComponents"),
        definitionsServiceUrl: server.getRelativeUrl("genericParamDefinitions"),
    })
}])

backgroundTaskJobModule.config(["backgroundTaskJobUrlsProvider", function (provider) {
    provider.setUrls({
        filterService: server.getRelativeUrl("backgroundTaskJob"),
        cancelJob: server.getServiceUrl("backgroundTaskJobCancel"),
        violations: server.getServiceUrl("backgroundTaskJobViolations"),
        canDownloadTask: server.getServiceUrl("backgroundTaskJobCanDownload"),
        downloadTask: server.getServiceUrl("backgroundTaskJobDownload"),
        getExportType: server.getServiceUrl("backgroundTaskJobExportType"),
    })
}])

nlgLGPDModule.config(["nlgLGPDProvider", function (nlgLGPDProvider) {
    nlgLGPDProvider.setServicePath({
        attributePath: "/lgpd/attributable",
        classificationPath: "/lgpd/classifiable",
        genericParamPath: "/lgpd/generic-param",
        filterServicePath: "/lgpd/entity",
        sqlFilterServicePath: "/lgpd/script-sql",
        mainArtifactName: "r2",
        availableServices: [
            {
                artifactName: "r2"
            },
            {
                artifactName: "monitoring"
            },
            {
                artifactName: "tracking"
            },
            {
                artifactName: "userManagement"
            }
        ],
    })
}])

microstrategyModule.config(["microstrategyServiceUrlProvider", function (microstrategyServiceUrlProvider) {
    microstrategyServiceUrlProvider.setUrl({
        microstrategyLibraryIdentifier: "B557CA3B16A7469AB7F129F2D4DE92CB",
        loginUrl: server.getServiceUrl("microstrategy-login"),
        logoutUrl: server.getServiceUrl("microstrategy-logout"),
        configurationUrl: server.getServiceUrl("microstrategy-configuration"),
        isAllowedUrl: server.getServiceUrl("microstrategy-is-allowed"),
        renewSessionUrl: server.getServiceUrl("microstrategy-renew-session"),
        homeState: "r2.home"
    })
}])

remoteServerModule.config(["remoteServerUrlsProvider", function (remoteServerUrlsProvider) {
    remoteServerUrlsProvider.setUrls({
            "config-params.get-remote-config-params": server.getServiceUrl("config-params.remote-config-params"),
            "config-params.update-remote-config-params": server.getServiceUrl("config-params.remote-config-params"),
            "config-params.test-routing-connection": server.getServiceUrl("config-params.test-routing-connection"),
        }
    )
}])

tripOperationHistoryModule.config(["tripOperationHistoryServiceUrlProvider", function (tripOperationHistoryServiceUrlProvider) {
    tripOperationHistoryServiceUrlProvider.configure({
        tripOperationHistoryUrlForNodeIdentifier: server.getServiceUrl("tripOperationHistoryUrlForNodeIdentifier")
    })
}])

integrationDocumentationModule.config(["integrationDocumentationUrlsProvider", function (integrationDocumentationUrls) {
    integrationDocumentationUrls.setUrls({
        "web-services": gatewayServer.getServiceUrl("web-services")
    })
}])
integrationValidatorModule.config(["integrationValidatorUrlsProvider", function (integrationValidatorUrls) {
    integrationValidatorUrls.setUrls({
        "validator.dataSources": integration.getServiceUrl("validator.dataSources"),
        "validator.interfaces": integration.getServiceUrl("validator.interfaces"),
        "validator": integration.getServiceUrl("validator"),
    })
}])
remoteRoutingModule.config(["remoteRoutingUrlsProvider", function (remoteRoutingUrlsProvider) {
    remoteRoutingUrlsProvider.setUrls({
        "orchestrator.get-mapped-machine-types": server.getServiceUrl("orchestrator.get-mapped-machine-types"),
        "orchestrator.remote-type-configuration": server.getServiceUrl("orchestrator.remote-type-configuration"),
        "orchestrator.create-remote-type-configuration": server.getServiceUrl("orchestrator.create-remote-type-configuration"),
        "orchestrator.update-type-configuration": server.getServiceUrl("orchestrator.update-type-configuration"),
        "orchestrator.test-routing-parallelism": server.getServiceUrl("orchestrator.test-routing-parallelism"),
        "orchestrator.get-routing-availability": server.getServiceUrl("orchestrator.get-routing-availability")
    })
}])

monitoringIntegrationModule.config(["monitoringIntegrationUrlsProvider", function (monitoringIntegrationUrls) {
    monitoringIntegrationUrls.setUrls({
        "baseUrl": monitoringServer.getServiceUrl("integration-url")
    })
}])

hereMapsModule.config(["hereMapsConfigurationServiceUrlProvider", function (hereMapsConfigurationServiceUrlProvider) {
    hereMapsConfigurationServiceUrlProvider.configure({
        url: server.getServiceUrl("here-maps")
    })
}])